import { integrationApi } from "api/TenantSlug/Integration/api.ts";

import GetIntegrationsRequest = App.Http.Requests.Integration.GetIntegrationsRequest;

export function composeGetIntegrationQueryOptions(integrationId: string, request?: GetIntegrationsRequest) {
    return {
        queryKey: ["getIntegration", integrationId, request],
        queryFn: () => integrationApi.show(integrationId, request),
    };
}

export function getIntegrationQueryOptions(integrationId: string, request?: GetIntegrationsRequest) {
    return {
        ...composeGetIntegrationQueryOptions(integrationId, request),
        suspense: true,
    };
}
